import React from "react";
import { GitCompareIcon, Link2Icon, PenLineIcon, RefreshCwIcon, ScaleIcon, SearchIcon, BoxIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { painPoints } from "../../data/content";
const iconMap: Record<string, BoxIcon> = {
  connect: Link2Icon,
  search: SearchIcon,
  compare: GitCompareIcon,
  scale: ScaleIcon,
  practice: PenLineIcon,
  repeat: RefreshCwIcon
};
export function PainPoints() {
  return <section aria-labelledby="pain-points" className="bg-navy-900 px-4 py-16 text-white sm:py-24" data-id="element-271" data-mp="2clngckcktby3">
      <div className="mx-auto max-w-6xl" data-id="element-272" data-mp="2qkwm0q35onnt">
        <div id="pain-points" data-id="element-273" data-mp="2qkmugy2gq8g0">
          <SectionHeading dark title="Do you recognize yourself in any of these situations?" subtitle="If you answer YES to any of these questions, I created this educational collection with your learning needs in mind." data-id="element-274" data-mp="2qitx69dqp0ko" />
        </div>

        <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-275" data-mp="s6bt5aibxd5t">
          {painPoints.map(p => {
          const Icon = iconMap[p.icon];
          return <li key={p.title} className="flex gap-4 rounded-3xl bg-white/[0.06] p-6 ring-1 ring-white/10" data-id="element-276" data-mp="1n9mu1sat8bms">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cta text-navy-950" data-id="element-277" data-mp="1s4tt2mt4ws5d">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-278" data-mp="21wpsq2avcqbp" />
                </span>
                <div data-id="element-279" data-mp="21yj0jkx7xgla">
                  <h3 className="font-display text-xl font-extrabold leading-snug" data-id="element-280" data-mp="26w2mz842kzob">{p.title}</h3>
                  <p className="mt-2 leading-relaxed text-white/70" data-id="element-281" data-mp="2ax4fz77e8fhu">{p.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-14 max-w-2xl space-y-4 text-center text-lg leading-relaxed text-white/80" data-id="element-282" data-mp="2fxsf6g5s02n5">
          <p data-id="element-283" data-mp="2kv24lvt60eaz">
            And it shouldn’t be necessary to search through dozens of disconnected resources every time you want to review an
            ABG topic.
          </p>
          <p data-id="element-284" data-mp="qilxytwgiy5l">Sometimes the problem isn’t a lack of information.</p>
          <p className="font-display text-2xl font-black leading-snug text-cta sm:text-3xl [text-wrap:balance]" data-id="element-285" data-mp="iglb6nufj4k6">
            It’s the lack of a structured system for organizing and studying that information.
          </p>
          <p className="font-semibold text-white" data-id="element-286" data-mp="sfauml1z4x2j">That’s why I created the ABG Clinical Roadmap™.</p>
        </div>

        <SectionCta dark label="Yes! I want a structured ABG learning system" data-id="element-287" data-mp="nf6eiw4za4cu" />
      </div>
    </section>;
}